import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels',
	exact: true,
};
